import {
  fetchCredentialsByDatabaseId,
  selectCredentialsByDatabaseId,
  selectDatabaseById,
} from "@app/deploy";
import { useQuery, useSelector } from "@app/react";
import type { DeployDatabaseCredential } from "@app/types";
import { Box } from "../box";
import { DatabaseCredentialSecret } from "../database-credential-secret";
import { IconAlertTriangle } from "../icons";
import { tokens } from "../tokens";

export const Credential = ({
  cred,
  envId,
  externalHost = "",
  portMapping = [],
}: {
  cred: DeployDatabaseCredential;
  envId: string;
  externalHost?: string;
  portMapping?: [number, number][];
}) => {
  return (
    <div className="flex flex-col gap-2 mb-4">
      <h3 className={tokens.type.h3}>
        {cred.type} {cred.default ? "(default)" : ""}
      </h3>
      <div>
        <p className="text-base font-semibold text-gray-900">Connection URL</p>
        <div className="mt-1">
          <DatabaseCredentialSecret
            envId={envId}
            credentialId={cred.id}
            externalHost={externalHost}
            portMapping={portMapping}
          />
        </div>
      </div>
    </div>
  );
};

export const DatabaseCredentialBox = ({
  dbId,
  externalHost = "",
}: { dbId: string; externalHost?: string }) => {
  const creds = useSelector((s) => selectCredentialsByDatabaseId(s, { dbId }));
  useQuery(fetchCredentialsByDatabaseId({ dbId }));
  const db = useSelector((s) => selectDatabaseById(s, { id: dbId }));

  return (
    <Box>
      <h1 className="text-lg text-red-500 font-semibold flex items-center gap-2 mb-4">
        <IconAlertTriangle color="#AD1A1A" />
        Credentials - This information is sensitive: keep it safe!
      </h1>
      {creds.map((c) => {
        return (
          <Credential
            key={c.id}
            cred={c}
            envId={db.environmentId}
            externalHost={externalHost}
            portMapping={db.portMapping}
          />
        );
      })}
    </Box>
  );
};
